const STORAGE_KEY = "recent_searches";
const MAX_RECENT = 6;
let RECENT = [];
const initLookup = () => {
  try {
    RECENT = getRecentSearches();
  } catch { RECENT = []; }
};

const sanitizeQuery = (query) => {
  // Prevent cross-site scripting (XSS). The Autocomplete library uses "innerHTML"
  // rather than "textContent" as of 4/2025. Also, limit the length of the query
  // to 39 characters (the max length of a tag).
  return query.trim().replace(/</g, "&lt;").replace(/>/g, "&gt;").slice(0, 39);
};

const getRecentSearches = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const saveSearch = (query) => {
  const sanitizedQuery = sanitizeQuery(query);
  let searches = getRecentSearches().filter(item => item !== sanitizedQuery);
  searches.unshift(sanitizedQuery);
  if (searches.length > MAX_RECENT) searches = searches.slice(0, MAX_RECENT);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
};

const removeSearch = (query) => {
  let searches = getRecentSearches();
  const sanitizedQuery = sanitizeQuery(query);
  searches = searches.filter(item => item !== sanitizedQuery);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
  initLookup();
}

const appendCaliforniaDataCollectionNotice = (resultListEl, searchInputElement) => {
  // Notify California users that searches are saved
  if (searchInputElement.dataset.searchHistory === 'true' && searchInputElement.dataset.searchHistoryCaShowNotice === 'true') {
    const notice = document.createElement('div');
    notice.className = 'autoComplete_notice';
    notice.style.marginTop = '1.6rem';
    notice.textContent = 'Search keywords may be used to improve your shopping experience. Opt out via the privacy page form.'
    resultListEl.appendChild(notice)
  }
}

const recentSearchesLookup = (input, limit = 2) => {
  if (!input) return [];
  if (RECENT.length === 0) initLookup();
  const sanitizedQuery = sanitizeQuery(input);
  const suggestions = RECENT.filter(s => s.startsWith(sanitizedQuery)).slice(0, limit);
  return suggestions.map((term, index) => ({
    suggestion: term,
    type: 'recent-search',
    weight: limit - index,
  }));
}

export {
  getRecentSearches,
  saveSearch,
  removeSearch,
  appendCaliforniaDataCollectionNotice,
  recentSearchesLookup
};
